export enum AlertType {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  INSURER = 'insurer',
  INFO = 'info',
}
